<template>
    <MainLayout>
        <div class="w-100">
            <v-card class="mx-auto">
                <v-card-title>
                    <v-sheet :elevation="4"
                             class="icon--box">
                        <i class="fas fa-money-check" />
                    </v-sheet>

                    <span class="title ml-4">Aktualisierung der Stammdaten zur Berechnung des brachenüblichen Lohns</span>
                </v-card-title>

                <!-- Syncing indicator -->
                <v-card-text v-if="isSyncing" class="text-center">
                    <!-- style="color: grey" ensures it's not white on white -->
                    <i class="fas fa-cog fa-spin fa-3x mt-4" style="color: grey"></i>
                    <br />
                    <br />
                    <p>Datensynchronisierung läuft ...</p>
                </v-card-text>

                <!-- Last sync info (only when not syncing and a completed sync exists) -->
                <v-card-text v-if="!isSyncing && syncInfo">
                    <v-alert :value="true" type="info" class="mt-4">
                        <strong>Letzte Synchronisierung:</strong><br /> {{ formatDate(syncInfo?.created) }}
                        <br /><br />
                        <strong>Dauer:</strong> <br />{{ syncDuration }}
                    </v-alert>
  
                </v-card-text>

                <v-card-text class="text-right">
                    <v-btn class="btn-left mt-4"
                           color="success"
                           raised
                           :disabled="isSyncing"
                           title="Aktualisierung ausführen"
                           @click="berechnungsdatenAktualisieren">
                        <i class="fas fa-sync mr-3" :class="{ 'fa-spin': isSyncing }" /> Aktualisieren
                    </v-btn>
                </v-card-text>

                <v-alert v-if="errorObject" type="error" class="mx-4 mb-4">
                    {{ errorObject }}
                </v-alert>
            </v-card>
        </div>
    </MainLayout>
</template>
<script>
    import MainLayout from "@/layouts/MainLayout.vue";
    import { DoSyncData, GetSyncInfo } from "@/services/branchenueblicherLohn.service";

    export default {
        components: {
            MainLayout,
        },
        data() {
            return {
                isSyncing: true,
                syncInfo: null,
                errorObject: null,
            };
        },
        computed: {
            syncDuration() {
                if (!this.syncInfo) return "";
                const diffMs = new Date(this.syncInfo.modified) - new Date(this.syncInfo.created);
                const totalSeconds = Math.floor(diffMs / 1000);
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;
                if (minutes > 0) {
                    return `${minutes} Min. ${seconds} Sek.`;
                }
                return `${seconds} Sek.`;
            },
        },
        mounted() {
            this.checkSyncStatus();
        },
        methods: {
            checkSyncStatus() {
                GetSyncInfo(
                    (result) => {
                         this.syncInfo = result;
                        this.isSyncing = this.isSyncRunning(result);
                    },
                    (error) => {
                        this.errorObject = error;
                        console.error(error);
                    },
                );
            },
            isSyncRunning(info) {

                if (!info) return false;
                return new Date(info.created).getTime() === new Date(info.modified).getTime();
            },
            formatDate(dateStr) {
                if (!dateStr) return "";
                const date = new Date(dateStr);
                return date.toLocaleString("de-CH");
            },
            berechnungsdatenAktualisieren() {
                this.isSyncing = true;
                this.syncInfo = null;
                this.errorObject = null;

                DoSyncData(
                    (result) => {
                        console.log("DoSync response]:", result);
                        this.syncInfo = result;
                        this.isSyncing = this.isSyncRunning(result);
                    },
                    (error) => {
                        this.isSyncing = false;
                        this.errorObject = error;
                        console.error(error);
                    },
                );
            },
        },
    };
</script>

<style scoped>
    .icon--box {
        top: -30px;
        background-color: #e72b37;
        border-radius: 4px;
        text-align: start !important;
        padding: 28px !important;
        margin-bottom: -24px !important;
        font-size: 20px;
        color: #fff;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.5s ease-in-out;
        overflow: hidden;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        height: 0;
        max-height: 0;
        transform: translateY(-20px);
    }

    .fade-leave-to {
        transform: translateY(20px);
    }

    .fade-out-enter-active,
    .fade-out-leave-active {
        transition: all 1s ease-in-out;
        overflow: hidden;
    }

    .fade-out-enter,
    .fade-out-leave-to {
        opacity: 0;
        height: 0;
        max-height: 0;
        transform: translateY(20px);
    }

    .fade-out-leave-to {
        transform: translateY(-20px);
    }

    .animate-text {
        animation-name: slideInFromLeft;
        animation-duration: 1s;
    }

    @keyframes slideInFromLeft {
        0% {
            opacity: 0;
            transform: translateX(-20%);
        }

        100% {
            opacity: 1;
            transform: translateX(0);
        }
    }
</style>
